import { SheduleInfo } from 'types/state';

export function createSheduleInfo(): SheduleInfo {
  return {
    restaurant: '',
    hunting: ''
  };
}
